import { usePortal } from "@/utils/react/usePortal.tsx";
import type { TooltipComponentFormatterCallback, TooltipComponentFormatterCallbackParams } from "echarts";
import type { CallbackDataParams } from "echarts/types/dist/shared";
import type { ReactNode } from "react";
import invariant from "tiny-invariant";

export function useTooltipPortal(renderTooltip: (params: CallbackDataParams) => ReactNode) {
    const portal = usePortal();
    const formatter: TooltipComponentFormatterCallback<TooltipComponentFormatterCallbackParams> = (params) => {
        invariant(!Array.isArray(params), "Expected single params for tooltip");
        const content = renderTooltip(params);
        portal.setContent(content);
        return portal.element;
    };
    return {
        portal: portal.portalNode,
        formatter,
    };
}
